<template>
    <Breadcrumb :style="{ backgroundColor:'#Fff',padding: '0px 12px',height:'40px',lineHeight:'40px'}">
        <BreadcrumbItem 
            v-for="item in currentPath" 
            :href="item.path" 
            :key="item.name"
        >{{ itemTitle(item) }}</BreadcrumbItem>
    </Breadcrumb>
</template>

<script>
export default {
    name: 'breadcrumbNav',
    props: {
        currentPath: Array
    },
    methods: {
        itemTitle (item) {
              return item.title;
        }
    }
};
</script>

